import "./Quotation.scss";
import { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import quotationImg from "./../../../../../src/assets/img/service/quotation.png";
import PrintDocumentTemplate from "../../../../Components/PrintDocumentTemplate/PrintDocumentTemplate";
import { Icon } from "@mui/material";
import { useTranslation } from "react-i18next";
import { get } from "lodash";

const QuotationLogoComponent = ({ logo }) => {
  return (
    <div className="LogoArea">
      {logo ? <img className="Logo" alt="Logo" src={logo} /> : null}
    </div>
  );
};

export const Quotation = () => {
  const serviceOrderData = JSON.parse(
    sessionStorage.getItem("serviceOrderData"),
  );

  const { t } = useTranslation();
  const [logo, setLogo] = useState(null);
  const [settings, setSettings] = useState(null);

  const services = serviceOrderData?.valuationServices;
  const servicesMap = [
    {
      value: serviceOrderData.valuationServices.installationPriceHourlyRate,
      label: t("global:service.installation"),
    },
    {
      value: serviceOrderData.valuationServices.diagnosticsPriceHourlyRate,
      label: t("global:service.diagnostic"),
    },
    {
      value: serviceOrderData.valuationServices.itServicePriceHourlyRate,
      label: t("global:service.itService"),
    },
    {
      value: serviceOrderData.valuationServices.repairPriceHourlyRate,
      label: t("global:service.repair"),
    },
    {
      value: serviceOrderData.valuationServices.surveyPriceHourlyRate,
      label: t("global:service.survey"),
    },
  ];

  const scopeText = servicesMap
    .filter(item => item.value > 0)
    .map(item => item.label)
    .join(" / ");


  const totalSum = useMemo(() => {
    if (!services) return 0;

    const serviceKeys = ['diagnostics', 'installation', 'itService', 'repair', 'survey'];
    return serviceKeys.reduce((acc, key) => {
      const hourlyRate = services[`${key}PriceHourlyRate`] || 0;
      const laborHours = services[`${key}PriceLaborHours`] || 0;
      return acc + (hourlyRate * laborHours);
    }, 0);
  }, [services]);

  const summaryPartsNetto = serviceOrderData?.valuationParts.reduce((sum, el) => {
    const value = Number(el?.price || 0) * Number(el?.quantity || 0);
    return sum + value;
  }, 0).toFixed(2);

  const summaryAll = Number(summaryPartsNetto || 0) + Number(serviceOrderData?.transportCost || 0)

  const moneyAndVat = "PLN + 23% VAT"

  useEffect(() => {
    const loadData = async () => {
      const settingsResp = await GlobalAuthFetch({
        path: "/settings",
        disableError: true,
      });
      const data = settingsResp?.payload?.data || [];
      const formattedSettings = data.reduce((acc, item) => {
        acc[item.name] = item.value;
        return acc;
      }, {});
      setLogo(formattedSettings.LOGO);
      setSettings(formattedSettings);
    };

    loadData();
  }, []);

  const emailToSendList = get(serviceOrderData, "device.client.representatives", []).map(el => ({ label: `${el.name} ${el.lastname}`, value: el.email, uuid: el.uuid })).filter(el => Boolean(el.value));

  if (!settings) return null;


  return (
    <PrintDocumentTemplate
      fileName={`${t("global:service.quotation")}`}
      documentType="ServiceOrder"
      usersToSendEmail={emailToSendList}
    >
      {[
        <div key="page1">
          <div className="TargetPrintQuotationAreaFrom">
            <div className="HeaderArea">
              <QuotationLogoComponent logo={logo} />
              <div className="DateArea">
                <span>{settings.COMPANY_NAME}</span>
                <span>
                  {`${t("global:service.str")}`} {settings.COMPANY_ADDRESS},{" "}
                  {settings.COMPANY_POST_CODE} {settings.COMPANY_CITY}
                </span>
                <span>
                  {`${t("global:service.phone")}`} {settings.COMPANY_PHONE}
                </span>
                <span>{settings.WEBSITE}</span>
              </div>
            </div>

            <span className="Date">
              {`${settings.COMPANY_CITY} ${moment(serviceOrderData?.createdAt).format("DD-MM-YYYYr")}`}
            </span>
            <div className="quotation-details-container">
              <div className="red-separator">
                <div class="section-title">{`${t(
                  "global:service.servicePricing",
                )}`}</div>
                <div class="section-line"></div>
              </div>
              <div className="quotation-details">
                <div className="quotation-left">
                  <section className="info-block">
                    <span className="info-icon">
                      <Icon>art_track</Icon>
                    </span>
                    <h3 className="info-title">
                      {`${t("global:service.client")}`}
                    </h3>
                    <p className="info-value">
                      {serviceOrderData?.device?.client?.name}
                    </p>
                  </section>

                  <section className="info-block mt-5">
                    <span className="info-icon">
                      <Icon>art_track</Icon>
                    </span>
                    <h3 className="info-title">
                      {`${t("global:service.device")}`}
                    </h3>

                    <div className="kv">
                      <span>{`${t("global:service.modelName")}`}</span>
                      <span>
                        {
                          serviceOrderData?.device?.printerModel?.manufacturer
                            ?.entryName
                        }{" "}
                        {serviceOrderData?.device?.printerModel?.modelName}
                      </span>
                    </div>
                    <div className="kv">
                      <span>{`${t("global:service.sn")}`}</span>
                      <span> {serviceOrderData?.device?.serialNumber}</span>
                    </div>
                    <div className="kv">
                      <span>{`${t("global:service.id")}`}</span>
                      {/* index zlecenia */}
                      <span>{serviceOrderData?.index}</span>
                    </div>
                  </section>
                </div>
                <div className="quotation-right">
                  <section className="info-block">
                    {/* Zakres naprawy */}
                    <h3 className="info-title">{`${t(
                      "global:service.scopeOfRepair",
                    )}`}</h3>

                    <div className="row grey-separator">
                      {/* Części, materiały eksploatacyjne: */}
                      <span>{`${t("global:service.PartsConsumables")}`}</span>
                      <span className="grey-text">{summaryPartsNetto} {moneyAndVat}</span>
                    </div>

                    <div className="row">
                      {/* Usługi */}
                      <span>{`${t("global:service.services")}`}</span>
                      <span className="grey-text">{totalSum.toFixed(2)} {moneyAndVat}</span>
                    </div>
                    <div className="row grey-separator">
                      <span className="grey-text">{scopeText} </span>
                    </div>

                    <div className="row grey-separator">
                      {/* Transport */}
                      <span>{`${t("global:service.transport")}`}</span>
                      <span className="grey-text">{serviceOrderData?.transportCost?.toFixed(2)} {moneyAndVat}</span>
                    </div>

                    <div className="row total">
                      {/* Razem */}
                      <span>{`${t("global:service.total")}`}</span>
                      <span>{summaryAll.toFixed(2)} {moneyAndVat}</span>
                    </div>

                    <div className="row">
                      <span>{`${t("global:service.valuationDate")}`}</span>
                      <span className="grey-text"> {moment(serviceOrderData?.quoteValidUntil).format("DD-MM-YYYY")}</span>
                    </div>

                    <p className="note">
                      {`${t("global:service.serviceWarrantyTime")}`}
                    </p>
                  </section>

                  <section className="info-block">
                    {/* Uwagi z wyceny */}
                    <h3 className="info-title">{`${t(
                      "global:service.comments",
                    )}`}</h3>
                    <span className="grey-text">{serviceOrderData?.additionalQuoteContent}</span>
                  </section>
                </div>
              </div>
              <div className="acceptance-container">
                <div class="acceptance">
                  {/* Akceptacja */}
                  <span class="text">{`${t(
                    "global:service.acceptance",
                  )}`}</span>
                  {/* Data */}
                  <span class="date">{`${t("global:service.date")}`}</span>
                  {/* Podpis */}
                  <span class="signature">{`${t(
                    "global:service.signature",
                  )}`}</span>
                </div>
              </div>
              <div className="red-separator">
                <div class="section-line"></div>
              </div>
              <div className="img-section">
                <img className="img" src={quotationImg} alt="Quotation Img" />
                <p className="info-text-value">
                  {" "}
                  {settings.SERVICE_QUOTATION_MARKETING_TEXT}
                </p>
              </div>
              <div className="red-separator">
                <div class="section-line"></div>
              </div>
              <div>
                <section className="info-block">
                  <h3 className="info-title">
                    {`${t("global:service.quotationContactText")}`}
                  </h3>
                  <p className="info-text-value">
                    {settings.SERVICE_QUOTATION_FOOTER_TEXT}
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>
      ]}
    </PrintDocumentTemplate>
  );
};
